module.exports = __webpack_public_path__ + "static/img/sous-main-calendrier.c525caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/sous-main-calendrier.jpg
// module id = A9uK
// module chunks = 0